import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async get(obj) {
    const link = obj.part_id ? `${obj.id}/${obj.part_id}` : `${obj.id}`;
    return await requestWrapper(null, 'GET', `/doc_classes/${link}`);
  },
  async create(elem) {
    return await requestWrapper(null, 'POST', '/doc_classes', null, elem);
  },
  async update(elem) {
    return await requestWrapper(null, 'PUT', `/doc_classes/${elem.id}`, null, elem);
  },
  async remove(id, query) {
    return await requestWrapper(null, 'DELETE', `/doc_classes/${id}`, query);
  },
};
